import React from 'react';
import './Badge.scss';

export default function Badge ({ children, type = 'success' }) {
    return (
        <span className={'badge badge-' + type}>
            {children}
        </span>
    );
};